/**
 * Treu Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RelationSubjectTypeEnum = 'None' | 'User' | 'Machine' | 'Owner';

export const RelationSubjectTypeEnum = {
    None: 'None' as RelationSubjectTypeEnum,
    User: 'User' as RelationSubjectTypeEnum,
    Machine: 'Machine' as RelationSubjectTypeEnum,
    Owner: 'Owner' as RelationSubjectTypeEnum
};

